module.exports = require('./lib/bind');



//////////////////
// WEBPACK FOOTER
// ./~/memoize-bind/index.js
// module id = 59
// module chunks = 0